import { render, staticRenderFns } from "./EstoqueItemForm.vue?vue&type=template&id=eec8dc6e&"
import script from "./EstoqueItemForm.vue?vue&type=script&lang=js&"
export * from "./EstoqueItemForm.vue?vue&type=script&lang=js&"
import style0 from "./EstoqueItemForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports